import { PageHeader } from "@bednbody/ui/components/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@bednbody/ui/components/tabs";
import { CurrentRanksTab } from "./CurrentRanksTab";
import { PerksTab } from "./PerksTab";
import { RulesTab } from "./RulesTab";

/**
 * Rankings — the Oct 11 meeting's one page for everything a rank is and does.
 * Super Admin only. Three tabs: who holds which rank, the rules that score a
 * month into a rank, and what each rank is worth.
 *
 * Only the perks that already exist are listed. A new perk needs an approved
 * value first (never-invent-policy.md), so there is no "add a perk" control.
 */
export function RankingsPage() {
  return (
    <div className="min-w-0 space-y-8">
      <PageHeader
        description="Monthly ranks for therapists and riders, the rules that set them, and what each rank earns. Super Admin only, and every change is recorded in the audit log."
        title="Rankings"
      />

      <Tabs defaultValue="ranks">
        <TabsList
          className="w-full min-w-0 max-w-full justify-start overflow-x-auto border-b border-border"
          variant="line"
        >
          <TabsTrigger className="flex-none px-3" value="ranks">
            Current ranks
          </TabsTrigger>
          <TabsTrigger className="flex-none px-3" value="rules">
            Rules
          </TabsTrigger>
          <TabsTrigger className="flex-none px-3" value="perks">
            Perks
          </TabsTrigger>
        </TabsList>
        <TabsContent value="ranks" className="mt-4">
          <CurrentRanksTab />
        </TabsContent>
        <TabsContent value="rules" className="mt-4">
          <RulesTab />
        </TabsContent>
        <TabsContent value="perks" className="mt-4">
          <PerksTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
